// @ts-nocheck
import React from 'react';
import styled from 'styled-components';

import Text from 'crehana-ui/Text';
import getStaticUrl from 'Jsx/Utils/getStaticUrl';
import MediumClear from 'crehana-icons/MediumClear';
import { SHOPPING_CART_TRACKS } from '../constants';
import { useTranslation } from '@crehana/i18n';

const StyledText = styled(Text)<{ smallsize: boolean | undefined }>`
  font-size: 16px;
  @media (min-width: 768px) {
    font-size: 20px;
  }
  @media (min-width: 1024px) {
    font-size: 24px;
  }
  ${props =>
    props.smallsize
      ? `
    font-size: 14px;
    @media (min-width: 768px) {
      font-size: 18px;
    }
  `
      : ''}
`;

const renderCopy = (membershipPrices, shoppingCartPrice, t) => {
  if (shoppingCartPrice < membershipPrices.total) {
    return (
      <p className="text-white font-subtitle3-md">
        ¡Por{` `}
        <StyledText
          type="h4"
          color="white"
          smallsize={
            membershipPrices.currencySymbol === 'CO$' ? true : undefined
          }
        >
          {`${membershipPrices.currencySymbol}${(
            membershipPrices.total - shoppingCartPrice
          ).toFixed(2)}`}
        </StyledText>
        {` `}
        {t('ACCESS_TO_ALL_COURSES', {
          defaultValue: 'más accede a todos los cursos!',
        })}
      </p>
    );
  }

  return (
    <p className="font-subtitle3-md text-white">
      ¡Ahorra&nbsp;
      <StyledText
        type="h4"
        color="white"
        smallsize={membershipPrices.currencySymbol === 'CO$' ? true : undefined}
      >
        {`${membershipPrices.currencySymbol}${(
          shoppingCartPrice - membershipPrices.total
        ).toFixed(2)}`}
      </StyledText>
      &nbsp; y llevate todo el catalogo!
    </p>
  );
};

const CloseBtn = styled.div`
  top: 0;
  right: 0;
  z-index: 10;
  cursor: pointer;
  padding: 8px;
`;

const Root = styled.div<{ bg: string }>`
  ${props =>
    props.bg
      ? `background-image: url(${props.bg});`
      : `background-color: black;`}
  background-size: cover;
  background-position: center;
`;

const MembershipUpsell = ({
  promo,
  price,
  hidePromo,
}: {
  promo: any;
  price: number;
  noBackground: boolean;
  hidePromo(): void;
}) => {
  const { t } = useTranslation();

  return (
    <Root
      bg={getStaticUrl('img/shopping-cart/membership-upsell-background.jpg')}
      className="w-full relative pl-24 pr-24 pt-16 pb-16 sm:pl-24 sm:pr-24 md:pr-64 md:pl-64 md:mt-24 lg:pr-32 lg:pl-32"
    >
      <a
        onClick={e => {
          e.preventDefault();
          setTimeout(() => {
            window.location.href = promo.urlCheckout;
          }, 0);
        }}
        href={promo.urlCheckout}
        className="w-full block text-center"
      >
        {renderCopy(promo.prices, price, t)}
      </a>
      <CloseBtn onClick={hidePromo} className="block absolute md:hidden">
        <MediumClear size={12} color="#fff" />
      </CloseBtn>
    </Root>
  );
};

export default MembershipUpsell;
